import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import Modals from "@insite/content-library/Components/Modals";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Page from "@insite/mobius/Page";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import * as React from "react";
import { css } from "styled-components";

const ProductComparePage = ({ id }: PageProps) => (
    <Page
        css={css`
            max-width: 100% !important;
            padding: 0 !important;
        `}
    >
        <Zone contentId={id} zoneName="Content00"></Zone>
        <StyledWrapper
            css={css`
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            css`
                                margin-top: 0px !important;
                                margin-bottom: 0px !important;
                            `,
                            css`
                                margin-top: 0px !important;
                                margin-bottom: 0px !important;
                            `,
                            css`
                                margin-top: 0px !important;
                                margin-bottom: 0px !important;
                            `,
                            css`
                                margin-top: -63px !important;
                                margin-bottom: 29px !important;
                            `,
                            css`
                                margin-top: -63px !important;
                                margin-bottom: 29px !important;
                            `,
                        ],
                        "min",
                    )}
            `}
        >
            <Zone contentId={id} zoneName="Content"></Zone>
        </StyledWrapper>

        <Modals />
    </Page>
);

const pageModule: PageModule = {
    component: ProductComparePage,
    definition: {
        hasEditableUrlSegment: false,
        hasEditableTitle: true,
        pageType: "System",
    },
};

export default pageModule;
/**
 * @deprecated Use string literal "ProductComparePage" instead of this constant.
 */
export const ProductComparePageContext = "ProductComparePage";
